import type { FieldProps } from 'formik';
import { Field } from 'formik';
import * as React from 'react';

import { PhoneInput } from '@components/PhoneInput';

interface FormikTelFieldProps {
  name: string;
  label?: string;
  required?: boolean;
  /**
   * ISO 3166-1 alpha-2 country code to seed the phone country/calling code
   * with, e.g. the value of an address country field.
   */
  country?: string;
  /**
   * Opt in to the input filling its container's width. Defaults to false so
   * existing consumers keep their current (content-sized) layout.
   */
  fullWidth?: boolean;
}

function FormikTelField({ ...props }: FormikTelFieldProps) {
  const { name, label, required, country, fullWidth } = props;

  return (
    <Field name={name}>
      {({
        field,
        meta,
        form: { handleBlur, setFieldTouched, setFieldValue },
      }: FieldProps<string>) => (
        <PhoneInput
          country={country}
          error={Boolean(meta.error && meta.touched)}
          fullWidth={fullWidth}
          helperText={meta.touched && meta.error ? meta.error : ''}
          label={label}
          name={name}
          onBlur={handleBlur}
          onChange={(value) => {
            if (!meta.touched) {
              setFieldTouched(field.name, true);
            }
            setFieldValue(field.name, value);
          }}
          required={required}
          value={field.value}
        />
      )}
    </Field>
  );
}

export default FormikTelField;
